<template>
    <div class="left">

        <div class="title reveal" id="tldr"> 
            <h1>{{ title }}</h1>
        </div>

        <div class="description reveal" id="tldr"> 
            <h3>{{ description }}</h3>
        </div>

        <div class="linkContainer reveal" id="tldr">
            <a class="line-link" href="http://apple.co/2zTFp76" target="_blank">
                {{ buttonText }}
            </a>
        </div>

    </div>

</template>

<script>

export default {
  name: 'TLDRLeftColumn',
  data() {
    return {
        title: 'TLDR',
        description: 'TLDR is a tool to easily save, categorize, and discuss the best articles you come across daily.\
         Rich notifications give you all the info you need, straight from the sources you trust',
        buttonText: 'Get the app'
    };
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

$lineHeight: 2px;
$lineWidthSmall: 15%;
$animationDuration: 0.5s;
$animationCurve: all $animationDuration cubic-bezier(0.22, 0.61, 0.36, 1);

.left {
    // overflow: hidden;
    text-align: left;
    max-width: 25em;
    font-family: 'Avenir';
}

h1 {
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 0.3em;
}

h3 {
    font-weight: 300;
}

.line-link {
    cursor: pointer;
    position: relative;
    // text-align: right;
    display: inline-block;
    padding-bottom: 0.5em;

    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: .3em;
    font-weight: 700;
    color: #46E4C1;

    transition: $animationCurve;
}

.linkContainer {
    text-align: right;
}

.line-link:before, .line-link:after {
    content: ' ';
    position: absolute;
    background: #46E4C1;
    height: $lineHeight;
    bottom: 0;

    transition: $animationCurve;
}

.line-link:before {
    width: $lineWidthSmall;
    left: 0;
    transition-delay: 0.5s;
}

.line-link:hover::before {
    width: 0%;

    transition: width 0.1ms cubic-bezier(0.22, 0.61, 0.36, 1);
    transition-delay: 0.1ms;
}

.line-link:after {
    width: 0%;
    right: 0;

}

.line-link:hover::after {
    width: 100%; 
    left: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Apps/TLDR/TLDRLeft.vue